/** Heuristic: lab / PDF swab values considered growth / positive. */
export function swabGrowthPositive(raw) {
  const s = String(raw ?? '').trim();
  if (!s || s === '—' || s === '-') return false;
  const low = s.toLowerCase();
  if (
    low.includes('negative') ||
    low.includes('no growth') ||
    low.includes('not detected') ||
    low === '0' ||
    low === 'nil' ||
    low === 'none' ||
    low === 'clean' ||
    low === 'nd' ||
    low === 'n/a'
  ) {
    return false;
  }
  if (low.includes('positive') || low.includes('growth') || low.includes('tntc') || low.includes('colonies')) {
    return true;
  }
  const numMatch = s.match(/-?\d+(\.\d+)?/);
  if (numMatch) {
    const n = parseFloat(numMatch[0]);
    if (n > 0) return true;
  }
  return false;
}

export function trimSwabField(v) {
  const s = String(v ?? '').trim();
  if (!s || s === '—' || s === '-') return '';
  return s;
}
